/**
 * @generated SignedSource<<59f5bdb957b366eb28e5f66104c86190>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type formTemplateOtherQuery$variables = {
  slug: string;
};
export type formTemplateOtherQuery$data = {
  readonly template: {
    readonly id: string;
    readonly version: {
      readonly " $fragmentSpreads": FragmentRefs<"NewSubmission_version">;
    } | null | undefined;
  } | null | undefined;
};
export type formTemplateOtherQuery = {
  response: formTemplateOtherQuery$data;
  variables: formTemplateOtherQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "formTemplateOtherQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Template",
        "kind": "LinkedField",
        "name": "template",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TemplateVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NewSubmission_version"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "formTemplateOtherQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Template",
        "kind": "LinkedField",
        "name": "template",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TemplateVersion",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TemplateField",
                "kind": "LinkedField",
                "name": "fields",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kind",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "data",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayOrder",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0510b758e7f9e2d8b8d74719c9c837ef",
    "id": null,
    "metadata": {},
    "name": "formTemplateOtherQuery",
    "operationKind": "query",
    "text": "query formTemplateOtherQuery(\n  $slug: String!\n) {\n  template(slug: $slug) {\n    id\n    version {\n      ...NewSubmission_version\n      id\n    }\n  }\n}\n\nfragment NewSubmission_version on TemplateVersion {\n  id\n  name\n  description\n  fields {\n    id\n    key\n    kind\n    name\n    parentId\n    data\n    displayOrder\n  }\n}\n"
  }
};
})();

(node as any).hash = "836ef7587fc9abdbef59b0ab524af15f";

export default node;
